module.exports = __webpack_public_path__ + "img/kjDetail.e566ec52.jpg";